import {API_DATA_LOADED} from './lib/worm/actions';
import {CHANGE_WAIT_PAGE, FILTERS_SELECT_MAP, FILTERS_APPLY, FILTERS_CLEAN} from './appActions';

let defaultState = {
    paging: {
        current: 0,
        total: null
    },
    waitPage: null,
    filters: {
        maps: []
    },
    filtersToLoad: {
        maps: []
    },
};

export default function reducer(state = null, action) {
    if (state === null)
        state = defaultState;

    switch (action.type) {
        case API_DATA_LOADED:
            const meta = action.value.meta;
            return {
                ...state,
                paging: meta.paging,
                waitPage: meta.paging.current
            };
    
        case CHANGE_WAIT_PAGE:
            return {
                ...state,
                waitPage: action.value
            };
            
        case FILTERS_SELECT_MAP:
            let map = action.value;
            let maps = state.filters.maps.slice();
            let position = maps.indexOf(map);
            position === -1 ? maps.push(map) : maps.splice(position, 1);

            return {
              ...state,
                filters: {
                    ...state.filters,
                    maps
                }
            };

        case FILTERS_CLEAN:
            return {
                ...defaultState
            };
            
        case FILTERS_APPLY:
            return {
                ...state,
                paging: {...defaultState.paging},
                waitPage: defaultState.waitPage,
                filtersToLoad: {...state.filters}
            };
    
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redusers.js